import IAnalyticsAction from "../IAnalyticsAction";

export default function sendReportHandler(): IAnalyticsAction | undefined {
    return {
        category: "interaction",
        object: "message",
        name: "show",
        addition: "mainmenu_credits_reportproblem_reported"
    };
}